import Vue from 'vue'
import Vuex from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export const getDefaultState = () => ({
  vData: {
    Vid: 0,
    BillNumber: '',
    Passengers: 0,
    PassengersChildren: 0,
    Equipment: 0,
    TravelDay: new Date(),
    Flight: {
      Iata: '',
      Departure: '',
      Arrivals: '',
      ScheduledTime: '00:00',
      ExpectedTime: '00:00',
    },
    PickupTime: '00:00',
    PriceExtra: 0,
    Price: 0,
    Customer: 0,
    PickUpPassengerIdentId: '',
    PickUpPassengerNumber: '',
    DestinationPassengerIdentId: '',
    DestinationPassengerNumber: '',
    PickUpAddressContact: {
      Name: '',
      Phone: '',
      Phone2: '',
      Fax: '',
      Email: '',
      Web: '',
    },
    PickUpAddress: {
      Street: '',
      ZipCode: '',
      Location: '',
      District: '',
    },
    DestinationAddressContact: {
      Name: '',
      Phone: '',
      Phone2: '',
      Fax: '',
      Email: '',
      Web: '',
    },
    DestinationAddress: {
      Street: '',
      ZipCode: '',
      Location: '',
      District: '',
    },
    Description1: '',
    Description2: '',
    DescriptionInvoice: '',
    DescriptionPdf: '',
  },
  cData: {
    IdentId: 0,
    CustomerNumber: '',
    Name: '',
    Address: {
      Street: '',
      ZipCode: '',
      Location: '',
      District: '',
    },
    Contact: {
      Name: '',
      Phone: '',
      Phone2: '',
      Fax: '',
      Email: '',
      Web: '',
    },
    VatId: 1,
    PaymentMethod: 1,
    VatType: 0,
    EmailBilling: '',
    InvoiceDispatch: 1,
    Commission: 0,
    BankDetails: {
      AccountOwner: '',
      Iban: '',
      Bic: '',
    },
    AdditionalAddress: '',
    Info: '',
  },
  watch: 0,
})

export default {
  state: getDefaultState(),
  mutations: {
    VOUCHER_CLEAR(state) {
      Object.assign(state, getDefaultState())
      state.watch = new Date()
    },
    VOUCHER_SET_PICKUP_ADDRESS(state, data) {
      state.vData.PickUpAddress = data
      state.watch = new Date()
    },
    VOUCHER_SET_PICKUP_CONTACT(state, data) {
      state.vData.PickUpAddressContact = data
      state.watch = new Date()
    },
    VOUCHER_SET_PICKUP_IDENT_ID(state, id) {
      state.vData.PickUpPassengerIdentId = id
      state.watch = new Date()
    },
    VOUCHER_SET_PICKUP_NUMBER(state, number) {
      state.vData.PickUpPassengerNumber = number
      state.watch = new Date()
    },
    // DESTINATION
    VOUCHER_SET_DESTINATION_ADDRESS(state, data) {
      state.vData.DestinationAddress = data
      state.watch = new Date()
    },
    VOUCHER_SET_DESTINATION_CONTACT(state, data) {
      state.vData.DestinationAddressContact = data
      state.watch = new Date()
    },
    VOUCHER_SET_DESTINATION_IDENT_ID(state, id) {
      state.vData.DestinationPassengerIdentId = id
      state.watch = new Date()
    },
    VOUCHER_SET_DESTINATION_NUMBER(state, number) {
      state.vData.DestinationPassengerNumber = number
      state.watch = new Date()
    },
    VOUCHER_SET_CUSTOMER(state, data) {
      state.cData = data
      state.watch = new Date()
    },
    VOUCHER_SET_DATA(state, payload) {
      console.log(Object.getOwnPropertyNames(payload))

      Object.getOwnPropertyNames(payload).forEach((name, i) => {
        if(name == "TravelDay") {
          const d =   new Date().getTime() + Math.random();

          state.vData[name] = new Date(d);
        }

        state.vData[name] = payload[name]
      })
      state.watch = new Date()
    },
  },
  actions: {
    VOUCHER_CLEAR(context) {
      context.commit('VOUCHER_CLEAR')
      return true
    },
    VOUCHER_SET_DATA(context, payload) {
      context.commit('VOUCHER_SET_DATA', payload)
    },
    VOUCHER_GET_PICKUP_ADDRESS_BY_NUMBER(context, Number) {
      return new Promise((resolve, reject) => {
        this._vm.$http.get(`/address/${Number}`)
          .then(resp => {
            context.commit('VOUCHER_SET_PICKUP_ADDRESS', resp.data.Address)
            context.commit('VOUCHER_SET_PICKUP_CONTACT', resp.data.Contact)
            context.commit('VOUCHER_SET_PICKUP_IDENT_ID', resp.data.AddressIdentId)
            context.commit('VOUCHER_SET_PICKUP_NUMBER', resp.data.AddressId)
            resolve(resp)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    VOUCHER_GET_DESTINATION_ADDRESS_BY_NUMBER(context, Number) {
      return new Promise((resolve, reject) => {
        this._vm.$http.get(`/address/${Number}`)
          .then(resp => {
            context.commit('VOUCHER_SET_DESTINATION_ADDRESS', resp.data.Address)
            context.commit('VOUCHER_SET_DESTINATION_CONTACT', resp.data.Contact)
            context.commit('VOUCHER_SET_DESTINATION_IDENT_ID', resp.data.AddressIdentId)
            console.log(resp.data)
            context.commit('VOUCHER_SET_DESTINATION_NUMBER', resp.data.AddressId)
            resolve(resp)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    VOUCHER_GET_CUSTOMER_BY_NUMBER(context, Number) {
      return new Promise((resolve, reject) => {
        this._vm.$http.get(`/customer/customerNumber/${Number}`)
          .then(resp => {
            context.commit('VOUCHER_SET_CUSTOMER', resp.data)
            context.commit('VOUCHER_SET_DATA', { Customer: resp.data.IdentId })
            resolve(resp)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    VOUCHER_GET_CUSTOMER_BY_IDENT_ID(context, id) {
      return new Promise((resolve, reject) => {
        this._vm.$http.get(`/customer/customerId/${id}`)
          .then(resp => {
            context.commit('VOUCHER_SET_CUSTOMER', resp.data)
            context.commit('VOUCHER_SET_DATA', { Customer: resp.data.IdentId })
            resolve(resp)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    VOUCHER_SAVE(context) {
      return new Promise((resolve, reject) => {
        delete context.state.vData.Id
        this._vm.$http.post('/voucher/set', JSON.stringify(context.state.vData))
          .then(resp => {
            if (resp.data.success) {
              if (context.state.vData.Vid === resp.data.newVid) {
                this._vm.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Info',
                    icon: 'CheckIcon',
                    text: `Voucher (${resp.data.newVid}) wurde gespeichert.`,
                    variant: 'success',
                  },
                },
                {
                  timeout: 10000,
                })
                resolve(true)
              }
              context.commit('VOUCHER_SET_DATA', { Vid: resp.data.newVid })
            }
          })
          .catch(err => {
            console.error(err)
          })
      })
    },
    VOUCHER_GET(context, vid) {
      return new Promise((resolve, reject) => {
        this._vm.$http.get(`/voucher/get/${vid}`)
          .then(resp => {
            context.commit('VOUCHER_SET_DATA', resp.data)
            context.dispatch('VOUCHER_GET_CUSTOMER_BY_IDENT_ID', resp.data.Customer)
          })
          .catch(err => {
            console.error(err)
          })
      })
    },
  },
  modules: {},
}
